import { DefineComponent } from 'vue'

export default function scrollToElementIfNeeded(element: Element | DefineComponent | null): void {
  if (!element) {
    return
  }

  const isVueComponent = (e: DefineComponent | Element): e is DefineComponent => !!(e as DefineComponent)?.$el
  const isHtmlElement = (e: Element): e is HTMLElement => 'offsetTop' in e

  let htmlElement: HTMLElement

  if (isVueComponent(element)) {
    htmlElement = element.$el
  } else if (isHtmlElement(element)) {
    htmlElement = element
  } else {
    return
  }

  const md = window.matchMedia('(min-width: 748px)')
  const lg = window.matchMedia('(min-width: 1024px)')

  let offset = 60

  if (lg.matches) {
    offset = 0
  } else if (md.matches) {
    offset = 90
  }

  const rect = htmlElement.getBoundingClientRect()
  const isVisible = (
    rect.top >= offset
    && rect.left >= 0
    && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )

  if (!isVisible) {
    window.scrollTo({
      top: (rect.top + document.documentElement.scrollTop) - offset - 10,
      left: 0,
      behavior: 'smooth',
    })
  }
}
